export function findSelectedSku(contentData, currentAttributeState) {
  return contentData.skus.find((sku) => {
    return sku.definingAttributes.every((attribute) => {
      const selected = currentAttributeState[attribute.name]?.selectedValue;
      return (
        selected !== undefined && selected.toString().toLowerCase() === attribute.value.value.toString().toLowerCase()
      );
    });
  });
}

export async function fetchImboxAvailability(selectedSku, { wasParms }) {
  try {
    const response = await fetch('/wcs/resources/store/301/dynamicInventory/GetSkuInformation', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sku: selectedSku.partnumber }),
      credentials: 'omit',
    });
    if (!response.ok) throw new Error('Network response was not ok');
    const data = await response.json();
    const skuInfoArr = data?.response?.skuInformation;
    const skuInformation =
      Array.isArray(skuInfoArr) && skuInfoArr[0] && Object.keys(skuInfoArr[0]).length > 0 ? skuInfoArr[0] : null;
    if (!skuInformation) return false;
    const whseOnHand = skuInformation.rsvdtlOutput?.whseOnHand;
    const imboxWasparm = Number(wasParms.imboxOnHandThreshold);
    return (
      typeof whseOnHand === 'number' &&
      whseOnHand !== 0 &&
      typeof imboxWasparm === 'number' &&
      whseOnHand >= imboxWasparm
    );
  } catch (error) {
    console.error('Error fetching SKU information:', error);
    return false;
  }
}

export async function shouldShowImboxModal({ passedAppFunctions, contentData, currentAttributeState }) {
  const isCountryUS = passedAppFunctions?.country === 'US';
  const imboxWasparm = !!(
    passedAppFunctions?.wasParms?.imboxOnHandThreshold && passedAppFunctions.wasParms.imboxOnHandThreshold !== '0'
  );
  const itemCanBeImboxed = contentData.skus.some((sku) => sku.imbox === true);

  if (isCountryUS && imboxWasparm && itemCanBeImboxed) {
    const selectedSku = findSelectedSku(contentData, currentAttributeState);
    if (selectedSku?.imbox === true) {
      const imboxAvailable = await fetchImboxAvailability(selectedSku, passedAppFunctions);
      return !!imboxAvailable;
    }
  }
  return false;
}
